import { useNavigate, Form } from "@remix-run/react";
import { useRef } from 'react';
import { AvatarDropdownUI } from './AvatarDropdownUI';
import { Avatar } from '~/design-system/elements/Avatar/Avatar';
import { CreditRing } from '~/design-system/elements/Avatar/CreditRing';
import { useProfileAvatarUrl } from '~/hooks/profile/useProfileAvatarUrl';

interface AvatarDropdownProps {
  className?: string;
}

export const AvatarDropdown = ({ className }: AvatarDropdownProps) => {
  const navigate = useNavigate();
  const logoutFormRef = useRef<HTMLFormElement>(null);
  const profilePictureUrl = useProfileAvatarUrl() || undefined;

  const avatarTrigger = (
    <div style={{ cursor: 'pointer' }}>
      <CreditRing>
        <Avatar className={className} />
      </CreditRing>
    </div>
  );

  return (
    <>
      <AvatarDropdownUI
        className={className}
        avatarTrigger={avatarTrigger}
        profilePictureUrl={profilePictureUrl}
        onProfileClick={() => navigate('/profile')}
        onPricingClick={() => navigate('/pricing')}
        onBillingClick={() => navigate('/billing')}
        onBrandKitsClick={() => navigate('/brand-kits')}
        onIntegrationsClick={() => navigate('/integrations')}
        onSettingsClick={() => navigate('/settings')}
        onSignOutClick={() => logoutFormRef.current?.submit()}
      />
      <Form ref={logoutFormRef} method="post" action="/auth/signout" style={{ display: 'none' }} />
    </>
  );
};